import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { Cms } from '@impact/data';
import { Subject } from 'rxjs';

import { NewCarsModule } from '../../new-cars/new-cars.module';
import { SpotsUiModule } from '../../spots/spots-ui.module';
import { carouselSpotData } from '../../core/helpers';

@Component({
    selector: 'app-vehicle-model-page',
    template: `
        <main>
            <app-carousel-spot *ngIf="data?.showTopBanner && topBannerData"
                [ngClass]="{'small-banner': data?.displaySmallBanner}"
                [data]="topBannerData"
                [lazyLoad]="true">
            </app-carousel-spot>
            <app-new-cars-page-header *ngIf="data" [data]="data"></app-new-cars-page-header>

            <section class="page-grid-content">
                <app-spot-grid [grid]="data?.mainGrid"></app-spot-grid>
            </section>
        </main>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
class NewVehicleModelPageComponent implements OnInit, OnDestroy {
    @Input() data: Cms.NewVehiclesModelPage;
    topBannerData: Cms.CarouselSpot;
    private unsubscribe = new Subject<void>();

    ngOnInit(): void {
        if (this.data.carouselContentTop) {
            this.topBannerData = carouselSpotData(this.data.carouselContentTop);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}

@NgModule({
    declarations: [NewVehicleModelPageComponent],
    imports: [
        NewCarsModule,
        SpotsUiModule,
        CommonModule
    ],
})
class VehicleModelPageModule {}

export const LazyComponent = NewVehicleModelPageComponent;
